"use strict";

import* as React from "react";
import SiteSelectorContainer from "./SiteSelectorContainer";

const SiteSelectorPage = () => (
    <div id="SiteSelectorPage" className="container-xs">
        <div className="account-header col-xs-12">
            <div className="image-container"><div className="transparentLogo"/></div>
        </div>
        <SiteSelectorContainer/>
    </div>
);

export default SiteSelectorPage;
